import { useEffect, useState } from 'react';

/**
 * Whether the browser thinks it has a connection.
 *
 * `navigator.onLine` is not a promise that requests will succeed - it only knows there is a network
 * interface, not that anything is reachable beyond it. That is enough for what it is used for here:
 * deciding whether a failure is worth a message of its own, and knowing when it is worth trying the
 * queue again.
 */
export const useOnlineStatus = (): boolean => {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
};
